import type { ReactNode } from 'react';

/**
 * La botonera del pie de un formulario o diálogo, alineada a la derecha; `flex-wrap` baja el último
 * botón en pantalla angosta. Sin margen superior propio: el ritmo vertical es del contenedor, y un
 * `mt-4` aquí se sumaría a su `space-y-*`. Los diálogos sueltos lo piden con `className`.
 */
export function FilaAcciones({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`flex flex-wrap justify-end gap-2 ${className}`}>{children}</div>;
}
